import { render } from "./ReportsPageDownloader.vue?vue&type=template&id=f142b4aa&ts=true"
import script from "./ReportsPageDownloader.vue?vue&type=script&lang=ts"
export * from "./ReportsPageDownloader.vue?vue&type=script&lang=ts"

import "./ReportsPageDownloader.vue?vue&type=style&index=0&id=f142b4aa&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__